import { makeErrorWithCode } from '@neo-one/utils';
export const InvalidContractPropertyStateError = makeErrorWithCode('INVALID_CONTRACT_PROPERTY_STATE', (contractParameterType) => `Expected contract parameter type, found: ${contractParameterType.toString(16)}`);
export const InvalidVersionError = makeErrorWithCode('INVALID_VERSION', (expected, value) => `Expected version to be ${expected}, found: ${value}`);

//# sourceMappingURL=errors.js.map
